import { READ_TIMEOUT_MS, runInEditQueue } from "@Utils/doc/editQueue";
import { readSnapshot, watchDocument } from "@Utils/doc/wordDocument";
import { fitSnapshot, snapshotDelta } from "@Utils/doc/wordShell";
const CONFLICT = 409;
const UPLOAD_ATTEMPTS = 3;
const LIVE_SYNC_MS = 1000;
let post = null;
let version = 0;
let accepted = null;
let running = Promise.resolve();
let queued = null;
export function connectWordSnapshots(next) {
    post = next;
    version = 0;
    accepted = null;
    return ()=>{
        if (post === next) post = null;
    };
}
const isUnchanged = (base, delta)=>!delta.paragraphs.length && !delta.changes && !delta.comments && JSON.stringify(delta.selection) === JSON.stringify(base.selection) && delta.order.length === base.paragraphs.length && delta.order.every(({ uid }, index)=>uid === base.paragraphs[index].uid);
async function upload(atLeast) {
    const send = post;
    if (!send) throw new Error("No chat to send the document snapshot to.");
    const read = await runInEditQueue(readSnapshot, READ_TIMEOUT_MS);
    for(let attempt = 0; attempt < UPLOAD_ATTEMPTS; attempt++){
        const snapshot = fitSnapshot({
            version: Math.max(version, atLeast) + 1,
            ...read
        });
        const delta = accepted && snapshotDelta(accepted, snapshot);
        if (accepted && delta && accepted.version > atLeast && isUnchanged(accepted, delta)) return accepted;
        const response = await send("/word-snapshot", delta ?? snapshot);
        if (response.ok) {
            version = Math.max(version, snapshot.version);
            accepted = snapshot;
            return snapshot;
        }
        const body = await response.json().catch(()=>({}));
        if (response.status !== CONFLICT) throw new Error(`Document snapshot refused: ${body.error ?? response.status}`);
        if (Number.isInteger(body.version)) version = Math.max(version, body.version);
        accepted = null;
    }
    throw new Error("Document snapshot refused: conflict");
}
export function uploadSnapshot(atLeast = 0) {
    if (queued) {
        queued.atLeast = Math.max(queued.atLeast, atLeast);
        return queued.promise;
    }
    const entry = {
        atLeast,
        promise: Promise.resolve()
    };
    entry.promise = running.then(()=>{
        queued = null;
        return upload(entry.atLeast);
    });
    running = entry.promise.catch(()=>undefined);
    queued = entry;
    return entry.promise;
}
export function syncWordLive() {
    let timer;
    const schedule = ()=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            uploadSnapshot().catch((error)=>console.warn("[word] live snapshot failed:", error));
        }, LIVE_SYNC_MS);
    };
    const stop = watchDocument(schedule);
    return ()=>{
        clearTimeout(timer);
        stop();
    };
}
